import type { SVGProps } from 'react';
import { useId } from 'react';

export interface BarCodedIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const BarCodedIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: BarCodedIconProps) => {
  const clipPathId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden={true}
      focusable="false"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
      <rect width="20" height="20" rx="10" fill="#94C947" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M5.45455 8.63636C5.18182 8.63636 5 8.45454 5 8.18181V6.36363C5 5.5909 5.5909 5 6.36363 5H8.18181C8.45454 5 8.63636 5.18182 8.63636 5.45455C8.63636 5.72728 8.45454 5.9091 8.18181 5.9091H6.36363C6.0909 5.9091 5.90908 6.09092 5.90908 6.36365V8.18183C5.9091 8.45454 5.72728 8.63636 5.45455 8.63636Z"
          fill="white"
        />
        <path
          d="M14.5456 8.63636C14.2729 8.63636 14.091 8.45454 14.091 8.18181V6.36363C14.091 6.0909 13.9092 5.90908 13.6365 5.90908H11.8183C11.5456 5.90908 11.3638 5.72726 11.3638 5.45453C11.3638 5.18181 11.5456 5 11.8183 5H13.6365C14.4092 5 15.0001 5.5909 15.0001 6.36363V8.18181C15.0001 8.45454 14.8183 8.63636 14.5456 8.63636Z"
          fill="white"
        />
        <path
          d="M8.18181 14.9996H6.36363C5.5909 14.9996 5 14.4087 5 13.636V11.8178C5 11.5451 5.18182 11.3633 5.45455 11.3633C5.72728 11.3633 5.9091 11.5451 5.9091 11.8178V13.636C5.9091 13.9087 6.09092 14.0906 6.36365 14.0906H8.18183C8.45455 14.0906 8.63638 14.2724 8.63638 14.5451C8.63636 14.8178 8.45454 14.9996 8.18181 14.9996Z"
          fill="white"
        />
        <path
          d="M13.6365 14.9997H11.8183C11.5456 14.9997 11.3638 14.8178 11.3638 14.5451C11.3638 14.2724 11.5456 14.0906 11.8183 14.0906H13.6365C13.9092 14.0906 14.091 13.9087 14.091 13.636V11.8178C14.091 11.5451 14.2729 11.3633 14.5456 11.3633C14.8183 11.3633 15.0001 11.5451 15.0001 11.8178V13.636C15.0001 14.4088 14.4092 14.9997 13.6365 14.9997Z"
          fill="white"
        />
        <path
          d="M9.09109 9.54564H7.27291C7.00018 9.54564 6.81836 9.36382 6.81836 9.09109V7.27291C6.81836 7.00018 7.00018 6.81836 7.27291 6.81836H9.09109C9.36382 6.81836 9.54564 7.00018 9.54564 7.27291V9.09109C9.54564 9.36382 9.36382 9.54564 9.09109 9.54564ZM7.72746 8.63654H8.63656V7.72744H7.72746V8.63654Z"
          fill="white"
        />
        <path
          d="M9.09109 13.1814H7.27291C7.00018 13.1814 6.81836 12.9996 6.81836 12.7268V10.9087C6.81836 10.6359 7.00018 10.4541 7.27291 10.4541H9.09109C9.36382 10.4541 9.54564 10.6359 9.54564 10.9087V12.7268C9.54564 12.9996 9.36382 13.1814 9.09109 13.1814ZM7.72746 12.2723H8.63656V11.3632H7.72746V12.2723Z"
          fill="white"
        />
        <path
          d="M12.7273 9.54564H10.9091C10.6364 9.54564 10.4546 9.36382 10.4546 9.09109V7.27291C10.4546 7.00018 10.6364 6.81836 10.9091 6.81836H12.7273C13 6.81836 13.1819 7.00018 13.1819 7.27291V9.09109C13.1819 9.36382 13 9.54564 12.7273 9.54564ZM11.3637 8.63654H12.2728V7.72744H11.3637V8.63654Z"
          fill="white"
        />
        <path
          d="M10.9091 11.8178C10.6364 11.8178 10.4546 11.6359 10.4546 11.3632V10.9087C10.4546 10.6359 10.6364 10.4541 10.9091 10.4541C11.1819 10.4541 11.3637 10.6359 11.3637 10.9087V11.3632C11.3637 11.6359 11.1819 11.8178 10.9091 11.8178Z"
          fill="white"
        />
        <path
          d="M12.7275 11.3632H12.2729C12.0002 11.3632 11.8184 11.1814 11.8184 10.9087C11.8184 10.6359 12.0002 10.4541 12.2729 10.4541H12.7275C13.0002 10.4541 13.182 10.6359 13.182 10.9087C13.182 11.1814 13.0002 11.3632 12.7275 11.3632Z"
          fill="white"
        />
        <path
          d="M12.7274 13.1816H11.3637C11.091 13.1816 10.9092 12.9997 10.9092 12.727C10.9092 12.4543 11.091 12.2725 11.3637 12.2725H12.7274C13.0001 12.2725 13.1819 12.4543 13.1819 12.727C13.1819 12.9997 13.0001 13.1816 12.7274 13.1816Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default BarCodedIcon;
